var scrollIcons = document.querySelectorAll('.scroll-icon');

function elementInViewport(el) {
  var rect = el.getBoundingClientRect();
  var windowHeight = window.innerHeight;
  return rect.top < windowHeight && rect.bottom >= 0;
}

function animateScrollIcon() {
  var scrollPosition = window.scrollY;

  scrollIcons.forEach(function(icon) {
    if (elementInViewport(icon)) {
      var scrollIconRect = icon.getBoundingClientRect();
      var iconTop = scrollIconRect.top;
      var iconBottom = scrollIconRect.bottom;
  
      var translateY = icon.parentElement.getBoundingClientRect().top * .3;
      if (icon.classList.contains('scroll-down')) {
        icon.style.transform = 'translate(-50%, 0%) translateY(' + - translateY + 'px)';   
      } else {
        icon.style.transform = 'translate(-50%, 0%) translateY(' + translateY + 'px)'; 
      }
    }
  });
}

window.addEventListener('scroll', function() {
  animateScrollIcon();
});

  
  